export default class Events
{
    static get SceneLoaded () { return "SCENE_LOADED"; }
    static get SceneReloaded () { return "SCENE_RELOADED"; }
    static get CharacterReloaded () { return "CHARACTER_RELOADED"; }
    static get SceneShown () { return "SCENE_SHOWN"; }
    static get ChangeEmotion () { return "CHANGE_EMOTION"; }
    static get MoveScene () { return "MOVE_SCENE"; }
    static get ReplaceCharacter () { return "REPLACE_CHARACTER"; }
    static get ReplaceScene () { return "REPLACE_SCENE"; }
    static get LoadScene () { return "LOAD_SCENE"; }
    static get LoadCharacter () { return "LOAD_CHARACTER"; }

    static get PlayCharacterAnimation () { return "PLAY_CHARACTER_ANIMATION"; }
    static get BounceCharacterIn () { return "BOUNCE_CHARACTER_IN"; }
    static get BounceCharacterOut () { return "BOUNCE_CHARACTER_OUT"; }
    static get UpdteSceneAndCharacter () { return "UPDATE_SCENE_AND_CHARACTER"; }
    static get ShowMaestro () { return "SHOW_MAESTRO"; }

}
